import React from "react";
import { useTranslation } from "react-i18next";
import { useFormContext, Controller } from "react-hook-form";
import { DropdownDevise, InputGroup } from "@components/tailwindComponents";
import { formatToNumber } from "@helpers/_functions";

export default function InputHourlyRate({
  readOnly = false,
}) {
  const {  control } = useFormContext();
  const { t: translate } = useTranslation([
    "pages.employés.parcours&Certifications",
    "message"
  ]);
  return (
    <div className="arh-mb-3">
      <div className="arh-w-full arh-relative arh-flex">
        <Controller
          control={control}
          name="hourlyRate"
          //rules={hourlyRate}
          render={({
            field: { onChange, name, value },
            fieldState: { invalid }
          }) => (
            <InputGroup
              name={name}
              onChange={(event) => {
                const nextValue = formatToNumber(event.target.value);
                onChange(nextValue);
              }}
              value={value}
              invalid={invalid}
              disabled={readOnly}
              placeholder={translate("Taux horaire")}
              label={translate("Taux horaire")}
              classParent="arh-w-full"
              classContent="arh-w-24"
              content={
                <DropdownDevise
                  control={control}
                  //rules={hourlyRateDevise}
                  name="hourlyRateDevise"
                  disable={readOnly}
                />
              }
            />
          )}
        />
      </div>
    </div>
  );
}
